import { createAsyncTypes } from 'utils/ActionCreator'

export const FETCH_SETTINGS_REQUEST_ASYNC = createAsyncTypes(
  'FETCH_SETTINGS_REQUEST',
  'Settings/GroupSettings/Wizard'
)
export const SAVE_SETTINGS_REQUEST_ASYNC = createAsyncTypes(
  'SAVE_SETTINGS_REQUEST',
  'Settings/GroupSettings/Wizard'
)

export const CLOSE_SAVED_MODAL = 'Settings/GroupSettings/Wizard/CLOSE_SAVED_MODAL'
export const CHANGE_WIZARD_STEP = 'Settings/GroupSettings/Wizard/CHANGE_WIZARD_STEP'
export const TOGGLE_DEFAULT_POLICY_CHECKBOX =
  'Settings/GroupSettings/Wizard/TOGGLE_DEFAULT_POLICY_CHECKBOX'

export const SAVE_INFO_FORM_ASYNC = createAsyncTypes(
  'SAVE_INFO_FORM',
  'Settings/GroupSettings/Wizard'
)
export const UPDATE_INFO_FORM = 'Settings/GroupSettings/Wizard/UPDATE_INFO_FORM'

export const END_USER_ALERTS_SAVE = 'Settings/GroupSettings/Wizard/END_USER_ALERTS_SAVE'

export const DEFAULT_INFO = {
  id: null,
  name: '',
  description: '',
}
